// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"de3b8990","379":"6b518b2f","591":"66d1f03c","703":"1757e838","787":"ba2f5d59"}[chunkId] + ".chunk.js";
};